import { ComponentProps, useRef } from "react";
import { useMatch, useSearchParams } from "react-router-dom";
import { getMFEConfig } from "@sunrun/sales-experience-shared";
import { useIframeMessages, useSynchronizeUrl } from "./common";
import type { IFrame } from "components/atoms/IFrame";

const useSupportAdapter = (): ComponentProps<typeof IFrame> => {
  const ref = useRef<HTMLIFrameElement | null>(null);
  const [searchParams] = useSearchParams();
  const config = getMFEConfig("support", "support");
  const basePath = config.iFrameUrl;
  const match = useMatch("/support/*");
  const src = `${basePath}/${match?.params["*"] ?? ""}?${searchParams}`;
  const { staticSrc } = useSynchronizeUrl(ref, src, basePath);
  useIframeMessages(ref, "Support", config.containerPath);
  return {
    ref,
    basePath: staticSrc,
    src,
    title: config.title,
  };
};

export { useSupportAdapter };
